import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

const AboutUsPage = () => (
    <Row>
        <Col className="help-or-about-us-page">
            <section className="title">ABOUT US</section>
            <section>
                Tour24 was developed by multifamily experts along with leaders in technology and
                innovation to accelerate the leasing process to benefit both the leasing staff and
                future renters.
            </section>
            <div>
                Tour24 is a mobile app that streamlines the rental touring process for consumers and
                property managers. Tour24’s cutting-edge technology integrates with the access
                systems at today’s buildings and creates self-guided tours. It serves as an
                extension to leasing teams to deliver more tours with maximum simplicity,
                flexibility and convenience.
            </div>
        </Col>
    </Row>
);

export default AboutUsPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/AboutUsPage.tsx